import { render, staticRenderFns } from "./questionmarkModal.vue?vue&type=template&id=2af02444&scoped=true&lang=html&"
import script from "./questionmarkModal.vue?vue&type=script&lang=js&"
export * from "./questionmarkModal.vue?vue&type=script&lang=js&"
import style0 from "./questionmarkModal.vue?vue&type=style&index=0&id=2af02444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af02444",
  null
  
)

export default component.exports